import { actionTypes } from '~/src/features/full-buy/store/index';

export const decProductQuantity = (productId: number) => ({
    type: actionTypes.DEC_PRODUCT_QUANTITY,
    payload: productId,
});
